import { useState, useEffect, createContext, useContext } from 'react';
import { typography, semantic } from '@/shared/theme/tokens';
import { Outlet } from 'react-router-dom';
import { Sidebar } from '@/widgets/Sidebar/Sidebar';
import { AppTopbar } from '@/widgets/AppTopbar/AppTopbar';
import { useThemeColors } from '@/shared/theme/useThemeColors';
import { ToastProvider } from '@/shared/ui/Toast';
import { useBreakpoint } from '@/shared/lib/useBreakpoint';

const TOPBAR_H = 56;
const SIDEBAR_W = 220;
const SIDEBAR_COLLAPSED_W = 52;

export const SidebarContext = createContext({ open: false, toggle: () => {} });
export function useSidebar() { return useContext(SidebarContext); }

export function AuthenticatedLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const c = useThemeColors();
  const { isMobile, isTablet } = useBreakpoint();

  // Auto-collapse on tablet, auto-hide on mobile
  useEffect(() => {
    if (isMobile) { setCollapsed(true); setMobileOpen(false); }
    else if (isTablet) { setCollapsed(true); }
  }, [isMobile, isTablet]);

  const sidebarW = isMobile ? 0 : (collapsed ? SIDEBAR_COLLAPSED_W : SIDEBAR_W);

  return (
    <SidebarContext.Provider value={{ open: mobileOpen, toggle: () => setMobileOpen((v) => !v) }}>
      <ToastProvider>
        <div style={{ height: '100vh', overflow: 'hidden', background: c.bgPage }}>
          <AppTopbar />

          {/* Mobile backdrop */}
          {isMobile && mobileOpen && (
            <div
              onClick={() => setMobileOpen(false)}
              style={{
                position: 'fixed', inset: 0, zIndex: 190,
                background: semantic.overlayMid,
              }}
            />
          )}

          <Sidebar
            collapsed={isMobile ? false : collapsed}
            onToggle={() => isMobile ? setMobileOpen((v) => !v) : setCollapsed((v) => !v)}
            mobileOpen={mobileOpen}
            isMobile={isMobile}
          />

          <main style={{
            marginTop: TOPBAR_H,
            marginLeft: sidebarW,
            padding: isMobile ? '12px' : '20px',
            height: `calc(100vh - ${TOPBAR_H}px)`,
            overflowY: 'auto',
            transition: 'margin-left 0.2s cubic-bezier(0.4,0,0.2,1)',
            fontFamily: typography.fontFamily.body,
          }}>
            <Outlet />
          </main>
        </div>
      </ToastProvider>
    </SidebarContext.Provider>
  );
}
